<template>

    <simple-dropdown
        position="right"
    >
        <template #trigger>
            <div class="flex items-center group cursor-pointer outline-none" tabindex="0">
                <avatar :image="currentUser?.image_url" size="small" class="mr-8">
                    {{ currentUser.initials }}
                </avatar>

                <div class="font-semibold leading-none mr-12">{{ currentCompany.name }}</div>

                <div class="text-primary-80 group-hover:text-primary trans-ease">
                    <svg-icon class="fill-current w-18 h-18" type="keyboard-arrow-down"/>
                </div>
            </div>
        </template>
        <template #content="{ close }">
            <div class="flex flex-col">
                <button
                    @click="close(); gotoProfile()"
                    class="flex gap-12 group p-16"
                >
                    <avatar
                        :image="currentUser?.image_url"
                    >
                        {{ currentUser.initials }}
                    </avatar>
                    <div>
                        <p class="font-semibold text-nowrap text-body text-black text-start">{{ currentUser.name }}</p>
                        <div class="flex items-center gap-4 font-semibold text-primary-80 group-hover:text-primary">
                            <svg-icon type="settings" class="w-16 h-16"></svg-icon>
                            <p class="first-letter:uppercase">{{ $t('auth.edit_profile') }}</p>
                        </div>
                    </div>
                </button>
                <div class="w-full border-t border-primary-20"></div>
                <div class="p-16">
                    <div class="mb-18">
                        <p class="font-semibold mb-8">{{ $t('general.user_companies') }}</p>
                        <p class="text-nowrap">{{ $t('general.switch_company') }}</p>
                    </div>
                    <ul class="max-h-320 overflow-y-auto space-y-8">
                        <li v-for="(company, index) in sortedCompanies" :key="index">
                            <radio-button
                                :value="company.id"
                                :checked="currentCompany.id"
                                @change="company.id !== currentCompany.id
                                    ? switchCurrentCompany(company.id)
                                    : null; close()"
                            >
                                <span class="text-body-sm">{{ company.name }}</span>
                            </radio-button>
                        </li>
                    </ul>
                </div>
                <div class="w-full border-t border-primary-20"></div>
                <simple-button
                    auto-width
                    class="m-16"
                    display="primary"
                    icon="logout"
                    icon-position="left"
                    look="primary"
                    size="small"
                    @click="handleLogout"
                >
                    {{ $t('auth.logout') }}
                </simple-button>
            </div>
        </template>
    </simple-dropdown>

</template>

<script>
import Avatar from '../ui/Avatar.vue';
import Loading from '../ui/Loading.vue';
import SvgIcon from '../ui/SvgIcon.vue';
import Form from '../../etc/forms/Form';
import SimpleDropdownVue from '../ui/SimpleDropdown.vue';
import Checkbox from "../forms/Checkbox.vue";
import RadioButton from "../forms/RadioButton.vue";
import SimpleButton from "../ui/SimpleButton.vue";
import {mapActions, mapState, mapStores} from "pinia";
import {useAuthenticationStore} from "../../state/modules/authentication";
import {useMainStore} from "../../state/store";

export default {
    components: {
        SimpleButton,
        RadioButton,
        Checkbox,
        'avatar': Avatar,
        'loading': Loading,
        'svg-icon': SvgIcon,
        'simple-dropdown': SimpleDropdownVue,
    },
    data: function () {
        return {
            form: new Form([]),
        };
    },
    computed: {
        ...mapStores(useMainStore),
        ...mapState(useAuthenticationStore, ['currentUser', 'currentCompany']),
        adminUser() {
            // adminUser will be set if an admin logged in into someone else's account.
            // This way we can log back in into the account of the admin without having to relog everytime
            return Jobtoolz.adminUser;
        },
        sortedCompanies() {
            return this.currentUser.companies.sort((a, b) => a.name.localeCompare(b.name));
        }
    },
    methods: {
        ...mapActions(useAuthenticationStore, ['logout', 'logoutSuccess', 'switchCurrentCompany']),
        handleLogout () {
            this.form.submit(() => this.logout())
            .then((data) => {
                this.logoutSuccess();

                if (data.refresh) {
                    location.reload();
                } else {
                    this.$router.push({ name: "login" });
                }
            });
        },
        gotoProfile () {
            this.$router.push({ name: "user" });
        }
    }
}
</script>
